// extracted by mini-css-extract-plugin
export var list = "AnimatedList-module--list--d9f50";